/* eslint 'no-redeclare': 'off' */
import React, { Component } from "react";
import { connect } from "react-redux";
import { Col, Button, FormGroup, Label } from 'reactstrap';
import { closeModalPopUp } from '../../../../action/modalStateAction';
import {PostParts,EditParts,PostPMParts,EditPMParts} from '../../../../action/workorderAction';
import {Icon}  from 'semantic-ui-react';
let SelectedworkOrderId = 0;
let IsEdit = false;
let IsPMDetail = false;

const ErrorSign = {
    color: '#D42D27',
    paddingLeft: '8px',
    paddingTop: '0px',
    paddingRight: '14px',
    width: '22px',
    height: '22px',
    top: '406px',
    left: '959px'
};

const RequiredText = {
    'color': '#D42D27', 
    'font-style': 'italic', 
    'font-size': '10px', 
    'font-family': 'Lato' 
};

const ErrorPadding = {
    'color': '#D42D27',
    'font-family': 'Lato',
    'font-style': 'italic',
    'border': '2px solid #D42D27',
    'height': '40px',
    'padding': '10px',
    'float': 'left',
    'background-color': '#FFFFFF',
    'font-size': '13px',
    'margin-bottom': '0px',
    'margin-top':'-5px'
};

const PaddingContainer = {
    paddingLeft:'10px',
    paddingTop:'10px'
};

class AddPartsForm extends Component{
    
    componentWillMount(){
        SelectedworkOrderId = this.props.ParentToChildData[0];  
        IsEdit = this.props.ParentToChildData[1];
        IsPMDetail = this.props.ParentToChildData[3];
        this.setState({
            PartsDetails : this.props.ParentToChildData[2]
        });
    }

    constructor(props){
        super(props);
        this.state = {
            error:{
                partname: false,
                quantity: false,
            },
            isError: false,
        }
        this.CloseModal = this.CloseModal.bind(this);
        this.SaveParts = this.SaveParts.bind(this);
    }

    CloseModal(){
        this.setState({PartsDetails:[]});
        IsEdit = false;
        this.props.closeModalPopUp("close");    
    }

    AllowOnlyNumbers = (event) => {
        var regex = new RegExp("^[0-9]*$");
        var inputValue = String.fromCharCode(event.keyCode || event.which);
        // allow numbers only.
        if (!regex.test(inputValue)) {
            event.preventDefault();
        }
    }

    SaveParts(){
      var Expression = new RegExp('^[0-9]*$');
      var partName = this.refs.New_Part_Name.value;
      var partNumber = this.refs.New_Part_PartNumber.value; 
      var partQuantity = this.refs.New_Part_Quantity.value; 

      if(IsEdit)
        var partId = this.state.PartsDetails[0].partId;
    
      if(partName === "" || (partQuantity !== "" && !Expression.test(partQuantity))){
            this.setState({ error:{
                partname: (partName !== "") ? false : true,
                quantity: (partQuantity !== "" && !Expression.test(partQuantity)) ? true : false,
            },   isError : true });
      }
      else {
        if(!IsPMDetail){
            var data = {
                "PartName" :  partName,
                "PartNumber" : partNumber === "" ? "" : partNumber,
                "Quantity" : partQuantity  === "" ? 0 : partQuantity,
                "WorkOrderID": SelectedworkOrderId
            }
            if(!IsEdit)
                this.props.PostParts(data);
            else
                this.props.EditParts(data,partId);
          }
         
         else{
            var data = {
                "PartName" :  partName,
                "PartNumber" : partNumber === "" ? "" : partNumber,
                "Quantity" : partQuantity  === "" ? 0 : partQuantity,
                "PMId": SelectedworkOrderId
            }
            if(!IsEdit)
                this.props.PostPMParts(data);
            else
                this.props.EditPMParts(data,partId);
          }
          this.props.closeModalPopUp("close"); 
        }
    }

    render( getLabels){
        let modal = null;
        let ErrorMessage,PartName=null, PartNumber=null,PartQuantity=null;
        let label = this.props.getLabels;
        let Header = "Add Parts";

        if(this.state.isError){
            ErrorMessage = <p style={ErrorPadding} >
                            <Icon name='exclamation triangle' style={ErrorSign} />
                            <b>Please correct all errors before continuing.</b>
                           </p>
        }
    
        if(IsEdit && this.state.PartsDetails != null && this.state.PartsDetails.length){
            PartName = this.state.PartsDetails[0].partName;
            PartNumber = this.state.PartsDetails[0].partNumber;
            PartQuantity = this.state.PartsDetails[0].quantity;
            Header = "Edit Parts";
        }

        modal = <div>
                    <p className='workordermainheaderlbl' style={PaddingContainer}>{Header}
                        <span className="wo_employee_closeIcon" onClick={()=>{this.CloseModal()}}>X</span>
                    </p>
                    <div style={{ borderTop:'1px solid #FFFFFF'}}/>
                    <div className="passwordContainer">
                    <FormGroup row style={{marginBottom:(this.state.error.partname) ? "0px":"10px"}}>
                        <Col sm={{size:6}}>
                            <label className={(this.state.error.partname) ? "errortext wo_headerlabel" :"wo_headerlabel"}>{label['WorkOrders.AddPartsName.Text'] !== undefined ? label['WorkOrders.AddPartsName.Text']+"*" : "Name*"}</label>
                            <input ref='New_Part_Name' className={(this.state.error.partname) ? "errorhighlight wo_details_textbox": "wo_details_textbox"} defaultValue={PartName} />
                            <span hidden={!this.state.error.partname}><Icon name='exclamation triangle' style={ErrorSign} /><br/>
                                <Label style={RequiredText}><b>An entry is required</b></Label></span>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col sm={{size:6}}>
                            <label className="wo_headerlabel">{label['WorkOrders.AddPartNumber.Text'] !== undefined ? label['WorkOrders.AddPartNumber.Text'] : "Part #"}</label>
                            <input ref='New_Part_PartNumber' className="wo_details_textbox" defaultValue={PartNumber} />
                        </Col>
                    </FormGroup>
                    <FormGroup row style={{marginBottom:(this.state.error.quantity) ? "0px":"10px"}}>
                        <Col sm={{size:6}}>
                            <label className={(this.state.error.quantity) ? "errortext wo_headerlabel" :"wo_headerlabel"}>{label['WorkOrders.AddPartQuantity.Text'] !== undefined ? label['WorkOrders.AddPartQuantity.Text'] : "Quantity"}</label>
                            {/* <input ref='New_Part_Quantity' className={(this.state.error.quantity) ? "errorhighlight wo_details_textbox": "wo_details_textbox"} defaultValue={PartQuantity} />
                            <span hidden={!this.state.error.quantity}><Icon name='exclamation triangle' style={ErrorSign} /><br/>
                                <Label style={RequiredText}><b>This field can only contain numeric values</b></Label></span> */}
                            <input ref='New_Part_Quantity'  className="wo_details_textbox" defaultValue={PartQuantity} onKeyPress={this.AllowOnlyNumbers} maxLength="10"/>
                        </Col>
                    </FormGroup>
                    </div>
                    <div style={{ borderTop:'1px solid #FFFFFF'}}/>
                    <div style={{marginTop:'10px', marginBottom:'25px'}}>
                        <span className="workorderlbl-noentry" style={{paddingLeft:'10px'}}>*required fields </span> 
                        <div style={{float:'right'}}>               
                            {ErrorMessage}  
                            <Button className="wo_cancel_btn" style={{'float': 'right', 'margin-left': '6px','margin-right':'10px' }} onClick={()=>{this.CloseModal()}} >CANCEL</Button>
                            <Button className="wo_save_btn" style={{'float': 'right', 'margin-left': '6px'}}  onClick={()=>{this.SaveParts()}} >FINISH</Button>
                        </div>
                    </div>
                </div>
        return(
            <div>
              {modal}
            </div>
        );
    }
};
const mapStateToProps = state => {
    return{
        getLabels: state.CulturalLabelsRootReducer.WorkOrderResource_LabelsBasedOnPreference
    };
};
const mapDispatchToProps = dispatch => {
    return {
        closeModalPopUp: (modaldata) => dispatch(closeModalPopUp(modaldata)),
        PostParts: (data)=> dispatch(PostParts(data)),
        EditParts: (data,partId)=> dispatch(EditParts(data,partId)),
        PostPMParts: (data)=> dispatch(PostPMParts(data)),
        EditPMParts: (data,partId)=> dispatch(EditPMParts(data,partId)),
    };
};
export default connect(mapStateToProps,mapDispatchToProps) (AddPartsForm);